const initialState = {
    token: localStorage.getItem("token"),
    username:localStorage.getItem("username"),
    isAuthenticated: null,
    isLoading: true,
    isSending:false,
    user: null,
    errors: {},
    personDetail:null,
};


export default function auth(state=initialState, action) {
    switch (action.type) {

        case 'USER_LOADING':
            return {...state, isLoading: true};

        case 'USER_LOADED':
            return {...state, isAuthenticated: true, isLoading: false, user: action.user, personDetail:action.data};

        case 'LOGIN_SUCCESSFUL':
            localStorage.setItem("token", action.data.token);
            localStorage.setItem("username", action.data.user.user_username);
            localStorage.setItem("user_id",action.data.user.user_id);
            let user_roles = action.data.user_roles;
            user_roles.forEach(function (item) {
                localStorage.setItem(item.rfun_name, true);
            });
            return {...state, ...action.data, isAuthenticated: true, isLoading: false, errors: null};


        case 'REGISTRATION_SUCCESSFUL':
            /*localStorage.setItem("token", action.data.token);
            localStorage.setItem("username", action.data.user.user_username);
            localStorage.setItem("user_id",action.data.user.user_id);
            let user_roles = action.data.user_roles;
            console.log(user_roles);
            user_roles.forEach(function (item) {
                localStorage.setItem(item.rfun_name, true);
            });*/

            return action;

        case 'AUTHENTICATION_ERROR':
            return {...state, ...action.data, isAuthenticated: false, isLoading: false, errors: null};
        case 'NOT_AUTHORIZED':
            return {...state, ...action.data, isAuthenticated: false, isLoading: false, errors: null};
        case 'LOGIN_FAILED':
        case 'REGISTRATION_FAILED':
        case 'LOGOUT_SUCCESSFUL':
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("user_id");
            localStorage.removeItem("user_roles");
            localStorage.clear();

            return {...state, errors: action, token: null, user: null,username:null,
                isAuthenticated: false, isLoading: false};
        case 'RESETPASSWORD_SUCCESFULL':
            return {...state, ...action, isSending: true};
        case 'RESETPASSWORD_FAILED':
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/auth.js